import React, { useEffect, useContext, useState } from 'react';
import Mapping from '../../../locales/messages/mapping';
import { Loader } from '../../commonComponents';
import { API_DETAILS, language } from 'Root/constants';
import VMContext from '../context';
import { isIFRAMEUrl, defineTypeCase } from 'Root/utils';

function addScript() {
  return new Promise((resolve, reject) => {
    (function (d, k) {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `${API_DETAILS.apiEndpoint}${k}`;
      s.onload = () => {
        resolve();
      };
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    })(document, API_DETAILS.accessKey);
  });
}

function getLangCode() {
  return Mapping[language];
}

function getFrame() {
  let frameWidth = 300;
  let frameHeight = 380;

  frameWidth = document.getElementById('YMK-module').clientWidth;
  frameHeight = document.getElementById('YMK-module').clientHeight;
  if(frameWidth > 600) {
    frameWidth = 600;
  }
  console.log(frameHeight, frameWidth);
  return [frameWidth, frameHeight];
}

function initYMK() {
  const vmLangCode = process.env.REACT_APP_LOCALE == 'hk' ? 'cht' : 'enu';
  const [frameWidth, frameHeight] = getFrame();
  const SHOW_PC_SEND_EMAIL = process.env.REACT_APP_SHOW_PERFECTCORP_SEND_MAIL || 'no';
  window.YMK.init({
    autoOpen: false,
    language: vmLangCode,
    height: frameHeight,
    width: frameWidth,
    disable2ColorComparison: true,
    showCompareCaption: false,
    enableEmailSharing: SHOW_PC_SEND_EMAIL === 'yes' ? true : false,
    intensitySliderDisplayMode: 'disabled',
  });
  window.YMK.open();
}

const emptyFunc = () => null;

const useInitYMK = ({
  onLoaded = emptyFunc,
  onEngineClosed = emptyFunc,
  onReset = emptyFunc,
  onCompare = emptyFunc,
  onLibLoaded = emptyFunc,
}) => {
  const [YMKInit, setYMKInit] = useState(false);
  useEffect(() => {
    if (window.YMK) {
      window.YMK.addEventListener('loaded', onLoaded);
      window.YMK.addEventListener('engineClosed', onEngineClosed);
      window.YMK.addEventListener('reset', onReset);
      window.YMK.addEventListener('compare', onCompare);

      return function cleanup() {
        window.YMK.removeEventListener('loaded');
        window.YMK.removeEventListener('engineClosed');
        window.YMK.removeEventListener('reset');
        window.YMK.removeEventListener('compare');
      };
    }
  }, [YMKInit]);
  useEffect(() => {
    window.ymkAsyncInit = initYMK;
    addScript().then(() => {
      onLibLoaded();
      setYMKInit(true);
    });
  }, []);
};

const Perfectcorp = ({
  onLoaded,
  onEngineClosed,
  onReset,
  onCompare,
  onLibLoaded: libLoaded,
  vmRef = null,
}) => {
  const { loader, setVmState } = useContext(VMContext);
  const onLibLoaded = () => {
    setVmState({ loader: false });
    libLoaded();
  };
  useInitYMK({
    onLoaded,
    onEngineClosed,
    onReset,
    onCompare,
    onLibLoaded,
  });

  return (
    <section className="content--component__ymk-module-inner">
      {loader && <Loader />}
      {/** --------------VM IFrame----------------------------- */}
      <div
        id="YMK-module"
        ref={vmRef}
        className="content--component__ymk-wrapper"
      ></div>
    </section>
  );
};

export default Perfectcorp;
